export class LocalStorage {
    private static tokenKey = 'token'

    static setItem(key: string, value: string) {
        localStorage.setItem(key, value)
    }

    static getItem(key: string) {
        return localStorage.getItem(key)
    }

    // Without "Remember me" the token lives in sessionStorage, so closing the
    // browser really ends the session instead of leaving it behind on the machine.
    private static store(remember: boolean): Storage {
        return remember ? localStorage : sessionStorage
    }

    static setToken(token: string, remember: boolean) {
        const item = {
            value: token,
            rememberMe: remember,
        }
        // Drop any copy in the other store first, so the two can never disagree
        this.removeToken()
        this.store(remember).setItem(this.tokenKey, JSON.stringify(item))
    }

    static getToken() {
        const itemStr = sessionStorage.getItem(this.tokenKey) ?? localStorage.getItem(this.tokenKey)
        if (!itemStr) {
            return null
        }
        return JSON.parse(itemStr)
    }

    static isTokenRemembered() {
        return this.getToken()?.rememberMe ?? false
    }

    static removeToken() {
        localStorage.removeItem(this.tokenKey)
        sessionStorage.removeItem(this.tokenKey)
    }
}
